import { render, staticRenderFns } from "./VFieldRadio.vue?vue&type=template&id=0b6d0da3&"
import script from "./VFieldRadio.vue?vue&type=script&lang=js&"
export * from "./VFieldRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6d0da3')) {
      api.createRecord('0b6d0da3', component.options)
    } else {
      api.reload('0b6d0da3', component.options)
    }
    module.hot.accept("./VFieldRadio.vue?vue&type=template&id=0b6d0da3&", function () {
      api.rerender('0b6d0da3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldRadio.vue"
export default component.exports